import { ChargeConstants } from 'features/Charge/chargeHelper';
import AppConstants from 'general/constants/AppConstants';
import _ from 'lodash';

const sortPermissionsByCodeOrder = (permissions, codeOrderList = []) => {
  if (!permissions?.length) return permissions ?? [];

  const orderMap = Object.fromEntries(codeOrderList.map((code, index) => [code, index]));
  const fallbackOffset = codeOrderList.length;

  return _.sortBy(
    permissions,
    (item) => orderMap[item.code] ?? fallbackOffset + Number(item.permissionId ?? 0)
  );
};

const getAdminPermissionCodeOrder = () =>
  Object.values(AppConstants.permissionCode).map((item) => item.code);

const getPermissionCodeOrder = (role, subRole) => {
  if (role === ChargeConstants.UserRole.ADMIN) {
    return getAdminPermissionCodeOrder();
  }

  return AppConstants.permissionCodeList.AGENCY[subRole] ?? [];
};

const permissionHelper = {
  sortPermissionsByCodeOrder,
  getAdminPermissionCodeOrder,
  getPermissionCodeOrder,
};

export default permissionHelper;
